@let _auth = auth$ | async;
@let _keys = keys$ | async;
@let _activeKey = activeKey$ | async;

@if (_activeKey) {
  <div class="control" [appDropdown]="dropdownContent">
    <ng-container *ngTemplateOutlet="itemTemplate; context: {key: _activeKey, withBalance: false}" />
    <app-svg-icon [name]="'arrow-down'" />
  </div>
}

<ng-template #dropdownContent>
  <div class="dropdown-content">
    @for (k of _keys; track k.id) {
      <div class="dropdown-item" [class.trade-perm]="true" [class.selected]="k === _activeKey" (click)="selectKey(k)" tabindex="0">
        <ng-container *ngTemplateOutlet="itemTemplate; context: {key: k, withBalance: true}" />
      </div>
    }
    @if (_auth) {
      <app-separator [type]="'horizontal'" [style]="'dashed'" />
      <a [href]="diaryUrl + 'lk/settings/connection'" target="_blank" class="icon-button"><app-svg-icon [name]="'addKey'" /> {{ 'keys.addAccount' | translate }}</a>
      <!-- <a [href]="diaryUrl + 'lk/settings/referral'" target="_blank">Открыть счёт</a> -->
    }
  </div>
</ng-template>

<ng-template #itemTemplate let-key="key" let-withBalance="withBalance">
  <div class="key-item" [title]="generateKeyHint(key)">
    <div class="key-item-left"
      [ngClass]="{
        'color-neg': !key.isDemo && key.canRead === false,
        'color-pos': !key.isDemo && key.canTrade === true,
      }"
    >
      <div class="key-market">
        <app-svg-market-icon [name]="key.market" />
        {{keyMarketName(key).boardShort}}
      </div>
      <div class="key-name">{{keysHelper.resolveKeyName(key)}}</div>
      @if (key.isDemo) {
        <app-svg-icon [name]="'eye'" />
      }
      @else if (!key.canRead) {
        <app-svg-icon [name]="'guard'" class="fill-neg" />
      }
      @else if (key.canTrade) {
        <app-svg-icon [name]="'unlock'" class="fill-pos" />
      }
      @else if (!key.canTrade) {
        <app-svg-icon [name]="'lock'" />
      }
    </div>
    @if (withBalance && key.canRead) {
      @let _balance = balances.get(key.id);
      <div class="key-balance"
        [ngClass]="{
          'color-dark': !key.isDemo && key.canTrade === true,
        }"
      >
        <app-round-currency-pretty [number]="_balance" [currencyCode]="'USD'" [showZeroCents]="true" [intValueClass]="'bold500'" [centValueClass]="'font10'" [currencySymbolClass]="'font10'" />
      </div>
    }
  </div>
</ng-template>
